import { Logger } from './Logger.mts';


const log = new Logger({ prefix: '❖ Storage' });


const DB_NAME = 'orbiit.ai';
const STORE_NAME = 'config';

export function getStorage(dbName: string, storeName: string) {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const req = indexedDB.open(dbName, 1);

    req.onerror = () => {
      log.error(`opening indexedDb failed ${req.error?.stack}`);

      reject(req.error);
    };
    req.onsuccess = () => resolve(req.result);

    req.onupgradeneeded = () => {
      req.result.createObjectStore(storeName);
    };
  });
}

export const storage = getStorage(DB_NAME, STORE_NAME);

export function createTransaction<T>(
  db: IDBDatabase,
  interaction: (objectStore: IDBObjectStore) => IDBRequest<T>,
  storeName = STORE_NAME,
) {
  return new Promise<T>((resolve, reject) => {
    const transaction = db.transaction(storeName, 'readwrite');

    transaction.oncomplete = () => resolve(objectStoreRequest.result);
    transaction.onabort = transaction.onerror = () => reject(transaction.error);

    const objectStoreRequest = interaction(transaction.objectStore(storeName));
  });
}
